import { c as _c } from "react/compiler-runtime";
import React, { type SVGProps } from 'react';
export const SortAscendingIcon = React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M7.99973 7.83315L7.99973 16.116" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M5.802 10.2742L7.99995 7.83276L10.1979 10.2742" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default SortAscendingIcon;